import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@examdojo/core/feature-flag';
import { BannerContent, isBannerConfig } from '@examdojo/core/ui/banner';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { distinctUntilChanged, map, Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InformativeBannerService {
  constructor(private readonly featureFlagService: FeatureFlagService<ExamdojoFeatureFlags>) {}

  readonly bannerContent$: Observable<BannerContent | null> = this.featureFlagService
    .select(ExamDojoFeatureFlag.InfoBanner)
    .pipe(
      map((flagValue): BannerContent | null => {
        if (typeof flagValue === 'string') {
          return flagValue.trim().length > 0 ? flagValue : null;
        }
        if (isBannerConfig(flagValue)) {
          return flagValue;
        }
        return null;
      }),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

  readonly enabled$: Observable<boolean> = this.bannerContent$.pipe(
    map((content) => content !== null),
    distinctUntilChanged(),
  );
}
